module.exports = __webpack_public_path__ + "img/448f725.jpg";